import React, { useState } from "react";
import water_menu_logo from "../../images/water_menu_logo.png";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import footer_logo from "../../images/logo-footer-crop.png";
import StaffLogin from "../../components/staff/login/StaffLogin";
import { Link, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetState } from "../../configurations/redux-configurations/actions/fieldAction";
import { resetUserState } from "../../configurations/redux-configurations/actions/userAction";
import StorageHelper from "../../helpers/StorageHelper";
import AuthHelper from "../../helpers/AuthHelper";
import {
  BACK_TO_LOGIN,
  WDP_TPNRD_NO_COST,
} from "../../configurations/MessageConstants";
import {
  EMPTY,
  LOG_OUT,
  LOGGING_OUT,
  STAFF_LOGGED_IN_USER,
} from "../../configurations/Constants";

function StaffHeader() {
  const dispatch = useDispatch();
  const [staffLoggedIn, setStaffLoggedIn] = useState(false);
  const [showStaffLogin, setShowStaffLogin] = useState(false);
  const [wellTestReportClicked, setWellTestReportClicked] = useState(false);
  const [wellChemigationReportClicked, setWellChemigationReportClicked] =
    useState(false);
  const [wellConnectionReportClicked, setWellConnectionReportClicked] =
    useState(false);
  const [fieldWellCropReportClicked, setFieldWellCropReportClicked] =
    useState(false);
  const [staffAsFarmerClicked, setStaffAsFarmerClicked] = useState(false);
  const [fieldTransferClicked, setFieldTransferClicked] = useState(false);
  const STAFF_ROUTES = [
    {
      name: "Well Test Report",
      condition: wellTestReportClicked,
      path: "well-test-report",
      setValue: setWellTestReportClicked,
    },
    {
      name: "Well Chemigation Report",
      condition: wellChemigationReportClicked,
      path: "well-chemigation-report",
      setValue: setWellChemigationReportClicked,
    },
    {
      name: " Well Connection Report",
      condition: wellConnectionReportClicked,
      path: "well-connection-report",
      setValue: setWellConnectionReportClicked,
    },
    {
      name: "Field Well Crop Report",
      condition: fieldWellCropReportClicked,
      path: "field-well-crop-report",
      setValue: setFieldWellCropReportClicked,
    },
    {
      name: "Staff-Farmer Login",
      condition: staffAsFarmerClicked,
      path: "staff-as-farmer-login",
      setValue: setStaffAsFarmerClicked,
    },
    {
      name: "Field Transfer",
      condition: fieldTransferClicked,
      path: "field-transfer",
      setValue: setFieldTransferClicked,
    },
  ];

  const handleLogOut = () => {
    dispatch(resetState());
    dispatch(resetUserState());
    AuthHelper.StaffSignOut();
    StorageHelper.setItem(LOGGING_OUT, LOG_OUT + Math.random());
    StorageHelper.removeItem(LOGGING_OUT);
    StorageHelper.clear();
  };

  const checkStaffLogin = (value) => {
    STAFF_ROUTES.forEach((route) => route.setValue(false));
    const route = STAFF_ROUTES.find((route) => route.path === value);
    if (route) {
      route.setValue(true);
    }
    if (StorageHelper.getItem(STAFF_LOGGED_IN_USER)) {
      setStaffLoggedIn(true);
    } else {
      setShowStaffLogin(true);
    }
  };

  const closeLoginModal = () => {
    setShowStaffLogin(false);
  };

  const current_staff = StorageHelper.getItem(STAFF_LOGGED_IN_USER);
  return (
    <header className="staff-header">
      <Navbar expand="sm">
        <Container fluid>
          <Navbar.Brand className={"brand-margin"}>
            <span className="header-logo-border">
              <img
                id="water_menu_logo"
                src={water_menu_logo}
                alt="Water Data Program Logo"
              />
            </span>
          </Navbar.Brand>
          <NavDropdown id="collasible-nav-dropdown" className="logo-menu">
            <NavDropdown.Item href="/well-test-form" className="mb-2">
              Well Test Form
            </NavDropdown.Item>

            {STAFF_ROUTES.map((route) => (
              <div key={route.path}>
                <NavDropdown.Item
                  onClick={() => checkStaffLogin(route.path)}
                  className="mb-2"
                >
                  {route.name}
                </NavDropdown.Item>
              </div>
            ))}
          </NavDropdown>

          <Navbar.Brand className="navbar-header-title">
            <img src={footer_logo} alt="footer-logo" />{" "}
            <span className="mt-5 footer-text">{WDP_TPNRD_NO_COST}</span>
          </Navbar.Brand>

          <Nav className="d-inline-block pull-right">
            {current_staff ? (
              <NavDropdown
                title={current_staff ? current_staff : "username"}
                id="collasible-nav-staff-dropdown"
              >
                <NavDropdown.Item href="/login" onClick={(e) => handleLogOut()}>
                  <i className="fa fa-sign-out" />
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              EMPTY
            )}
          </Nav>
          <Nav
            className={
              current_staff
                ? "navbar-index-position ms-auto d-none"
                : "navbar-index-position ms-auto"
            }
          >
            <Link to="/login" className="no-underline">
              {BACK_TO_LOGIN}
            </Link>
          </Nav>
          {staffLoggedIn &&
            STAFF_ROUTES.map(
              ({ condition, path }) =>
                condition && <Navigate key={path} to={path} />
            )}
          {!staffLoggedIn &&
            STAFF_ROUTES.map(
              ({ condition, path }) =>
                condition && (
                  <StaffLogin
                    key={path}
                    showStaffLogin={showStaffLogin}
                    closeLoginModal={closeLoginModal}
                    redirectTo={`/${path}`}
                  />
                )
            )}
        </Container>
      </Navbar>
    </header>
  );
}

export default StaffHeader;
